<script setup>
import { formatPlainDateByRegion } from '../../helpers';

const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <a target="_blank" :href="'https://www.youtube.com/watch?v=' + props.data.meta.snippet.resourceId.videoId"
        class="flex items-center p-2 rounded-lg border border-gray-200 transition-all ease-in-out hover:border-blue gap-2">
        <svg class="w-8 h-8 shrink-0" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11.5" cy="11.5" r="11.5" fill="#353CEE" />
            <path
                d="M17.5 10.634C18.1667 11.0189 18.1667 11.9811 17.5 12.366L9.25 17.1292C8.58333 17.5141 7.75 17.0329 7.75 16.2631L7.75 6.73686C7.75 5.96706 8.58333 5.48593 9.25 5.87083L17.5 10.634Z"
                fill="white" />
        </svg>

        <div class="flex-grow">
            <div class="flex flex-row items-center gap-2">
                <p class="text-sm text-gray-600">
                    {{ formatPlainDateByRegion(props.data.meta.snippet.publishedAt) }}
                </p>
            </div>
            <p class="font-semibold text-sm">
                {{ props.data.meta.snippet.title }}
            </p>
        </div>
    </a>
</template>
